export enum LocationsSort {
    CODE_ASC = 'code',
    NAME_ASC = 'name',
    ZONES_ASC = 'zonesCount',
    TAGS_ASC = 'tags',
    CODE_DESC = '-code',
    NAME_DESC = '-name',
    ZONES_DESC = '-zonesCount',
    TAGS_DESC = '-tags',
}
